import { render } from "./ComponenteFuturos.vue?vue&type=template&id=59a2599c&scoped=true"
import script from "./ComponenteFuturos.vue?vue&type=script&lang=js"
export * from "./ComponenteFuturos.vue?vue&type=script&lang=js"

import "./ComponenteFuturos.vue?vue&type=style&index=0&id=59a2599c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59a2599c"]])

export default __exports__